import React from 'react';
import QRCodeDialog from 'lib/components/Dialog/QRCode';

interface ReceiveDoneProps {
  title: string;
  confirmButtonText?: React.ReactNode;
  confirmCallback?: () => void;
  showClose?: boolean;
  footer?: React.ReactNode;
}

const ReceiveDone = ({
  title,
  confirmButtonText = '我知道了',
  confirmCallback,
  showClose,
  footer,
}: ReceiveDoneProps) => (
  <QRCodeDialog
    title={title}
    content="奖品已发送至游戏邮箱，请在游戏内查收"
    confirmButtonText={confirmButtonText}
    confirmCallback={confirmCallback}
    showClose={showClose}
    footer={footer}
  />
);

export const showReceiveDone = (params: ReceiveDoneProps) => (
  <ReceiveDone {...params} />
);
